import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title @model.friendlyUrl}}\n{{page-title \"Competitors\"}}\n\n<Settings::NwUrlCompetitors @url={{@model.url}} />")